<template>
  <label class="toggle">
    <small v-if="falseLabel">{{ falseLabel }}</small>

    <input v-model="state" type="checkbox" :true-value="trueValue" :false-value="falseValue" />
    <div class="switch">
      <div class="handle" />
    </div>

    <small v-if="trueLabel">{{ trueLabel }}</small>
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: [String, Boolean],
      default: undefined,
    },
    falseValue: {
      type: [String, Boolean],
      default: false,
    },
    trueValue: {
      type: [String, Boolean],
      default: true,
    },
    falseLabel: {
      type: String,
      default: undefined,
    },
    trueLabel: {
      type: String,
      default: undefined,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    state: {
      get() {
        return this.modelValue
      },
      set(value: string | boolean) {
        this.$emit('update:modelValue', value)
      },
    },
  },
})
</script>

<style lang="scss" scoped>
label.toggle {
  margin: 0;
  user-select: none;

  input {
    display: none;

    &:checked {
      + .switch {
        background-color: var(--primary);

        .handle {
          transform: translateX(calc(100% + 2px));
        }
      }
    }
  }

  .switch {
    margin: 0 5px;
    width: 2em;
    height: 1em;
    padding: 1px;
    background-color: #ccc;
    border-radius: 10px;

    display: inline-block;
    vertical-align: middle;

    .handle {
      position: relative;
      display: block;
      border-radius: 50%;
      height: 100%;
      aspect-ratio: 1;
      background-color: #eee;
      transition: transform 0.3s ease-in-out;
    }
  }
}
</style>
